import { BannersSectionLoadingDesktop } from './banners-section-loading-desktop.component';

export const BannersSectionLoading = () => {
  return (
    <BannersSectionLoadingDesktop className="hidden sm:flex sm:flex-col" />
  );
};
